import { isEmpty } from 'validate.js';
import get from 'lodash/get';

/* istanbul ignore next */
/* eslint-disable */
const constraints = {
    firstName: (value, attribute, attributeName, messages) => ({
        presence: { allowEmpty: false, message: "^Enter a valid first name" },
        format: {
            pattern: /^(?!.*([A-Za-z0-9À-ÖØ-öø-ÿ ])\1{2})(?=.*[a-zA-ZÀ-ÖØ-öø-ÿ])[A-Za-z0-9À-ÖØ-öø-ÿ,. -]{1,17}$/,
            message: `^${!get(messages, 'errorText', null) ? 'Enter a valid first name' : messages.errorText}`,
        },
    }),
    lastName: (value, attribute, attributeName, messages) => ({
        presence: { allowEmpty: false, message: "^Enter a valid last name" },
        format: {
            pattern: /^(?!.*([A-Za-z0-9À-ÖØ-öø-ÿ ])\1{3})(?=.*[a-zA-ZÀ-ÖØ-öø-ÿ])[A-Za-z0-9À-ÖØ-öø-ÿ,. -]{2,22}$/,
            message: `^${!get(messages, 'errorText', null) ? 'Enter a valid last name' : messages.errorText}`,
        },
    }),
    email: (value, attribute, attributeName, messages) => ({
        presence: { allowEmpty: false, message: '^Enter a valid email' },
        format: {
            pattern: /^[_A-Za-z0-9\-+]+(\.[_A-Za-z0-9\-]+)*@[A-Za-z0-9\-]+([\-_.][A-Za-z0-9]+)*(\.[A-Za-z]{2,})$/,
            message: `^${!get(messages, 'errorText', null) ? 'Enter a valid email' : messages.errorText}`,
        },
    }),
    forgotPasswordEmail: (value, attribute, attributeName, messages) => ({
        presence: { allowEmpty: false, message: '^Enter a valid email' },
        format: {
            pattern: /^[_A-Za-z0-9\-+]+(\.[_A-Za-z0-9\-]+)*@[A-Za-z0-9\-]+([\-_.][A-Za-z0-9]+)*(\.[A-Za-z]{2,})$/,
            message: `^${!get(messages, 'errorText', null) ? 'Enter a valid email' : messages.errorText}`,
        },
    }),
    forgotPasswordSliderEmail: (value, attribute, attributeName, messages) => ({
        presence: { allowEmpty: false, message: '^Enter a valid email' },
        format: {
            pattern: /^[_A-Za-z0-9\-+]+(\.[_A-Za-z0-9\-]+)*@[A-Za-z0-9\-]+([\-_.][A-Za-z0-9]+)*(\.[A-Za-z]{2,})$/,
            message: `^${!get(messages, 'errorText', null) ? 'Enter a valid email' : messages.errorText}`,
        },
    }),
    confirmEmail: () => ({
        presence: { allowEmpty: false },
        format: {
            pattern: /^[_A-Za-z0-9\-+]+(\.[_A-Za-z0-9\-]+)*@[A-Za-z0-9\-]+([\-_.][A-Za-z0-9]+)*(\.[A-Za-z]{2,})$/,
        },
    }),
    newEmail: () => ({
        presence: { allowEmpty: false },
        format: {
            pattern: /^[_A-Za-z0-9\-+]+(\.[_A-Za-z0-9\-]+)*@[A-Za-z0-9\-]+([\-_.][A-Za-z0-9]+)*(\.[A-Za-z]{2,})$/,
        },
    }),
    sliderNewEmail: () => ({
        presence: { allowEmpty: false },
        format: {
            pattern: /^[_A-Za-z0-9\-+]+(\.[_A-Za-z0-9\-]+)*@[A-Za-z0-9\-]+([\-_.][A-Za-z0-9]+)*(\.[A-Za-z]{2,})$/,
        },
    }),
    emailPassword: () => ({
        presence: { allowEmpty: false },
        format: {
            pattern: /^[\^A-Za-z0-9!"#$%&'()*+,\-./:;<=>?@[\\\]^_`{|}~\s]+$/,
        },
    }),
    currentPassword: () => ({
        presence: { allowEmpty: false },
        format: {
            pattern: /^[\^A-Za-z0-9!"#$%&'()*+,\-./:;<=>?@[\\\]^_`{|}~\s]+$/,
        },
    }),
    confirmPasswordWithSpace: () => ({
        presence: { allowEmpty: false },
        format: {
            pattern: /^[\^A-Za-z0-9!"#$%&'()*+,\-./:;<=>?@[\\\]^_`{|}~\s]+$/,
        },
    }),
    confirmPassword: () => ({
        presence: { allowEmpty: false },
        format: {
            pattern: /^[\^A-Za-z0-9!"#$%&'()*+,\-./:;<=>?@[\\\]^_`{|}~]+$/,
        },
    }),
    addressLineOne: () => ({
        presence: { allowEmpty: false },
        format: {
            pattern: /^[A-Za-z0-9#.\-\\/+=_,£ ]+$/,
        },
    }),
    addressLineTwo: () => ({
        presence: { allowEmpty: true },
        format: {
            pattern: /^[A-Za-z0-9#.\-\\/+=_,£ ]+$/,
        },
    }),
    addressLineThree: () => ({
        presence: { allowEmpty: true },
        format: {
            pattern: /^[A-Za-z0-9#.\-\\/+=_,£ ]+$/,
        },
    }),
    addressLineTwoForUs: () => ({
        presence: { allowEmpty: true },
        format: {
            pattern: /^[A-Za-z0-9#.\-\\/+=_,£ ]+$/,
        },
    }),
    company: () => ({
        presence: { allowEmpty: true },
        format: {
            pattern: /^(?!.*([A-Za-z ])\1{2})(?=.*[a-zA-Z])[A-Za-z ]{0,16}$/,
        },
    }),
    cardNumber: () => ({
        format: {
            pattern: /^[0-9]{11,16}$/,
        },
    }),
    cvv: () => ({
        format: {
            pattern: /^[0-9]{3}$/,
        },
    }),
    cvvAmex: () => ({
        format: {
            pattern: /^[0-9]{4}$/,
        },
    }),
    zip: () => ({
        presence: { allowEmpty: false },
        format: {
            pattern: /^[0-9]{5}$/,
        },
    }),
    zipInt: () => ({
        presence: { allowEmpty: false },
        format: {
            pattern: /^[\S][\S](.){2,8}$/,
        },
    }),
    zipAp: () => ({
        presence: { allowEmpty: false },
        format: {
            pattern: /^[039][0-9]{4,5}$/,
        },
    }),
    zipIN: () => ({
        presence: { allowEmpty: false },
        format: {
            pattern: /^\d{6}$/,
        },
    }),
    zipUK: () => ({
        presence: { allowEmpty: false },
        format: {
            pattern: /^(GIR|[A-Z]\d[A-Z\d]??|[A-Z]{2}\d[A-Z\d]??)[ ]??(\d[A-Z]{2})$/,
        },
    }),
    zipCA: () => ({
        presence: { allowEmpty: false },
        format: {
            pattern: /^([A-Z]\d[A-Z])\s?(\d[A-Z]\d)$/,
        },
    }),
    phoneNumber: () => ({
        presence: { allowEmpty: false },
        format: {
            pattern: /^[0-9]{10}$/,
        },
    }),
    city: () => ({
        presence: { allowEmpty: false },
        format: {
            pattern: /^[a-zA-Z\s]*$/,
        },
    }),
    province: () => ({
        presence: { allowEmpty: false },
        format: {
            pattern: /^[a-zA-Z\s]*$/,
        },
    }),
    state: () => ({
        presence: { allowEmpty: false },
        format: {
            pattern: /^[a-zA-Z\s]*$/,
        },
    }),
    orderNumber: () => ({
        presence: { allowEmpty: false },
        format: {
            pattern: /^[0-9-]{19}$/,
        },
    }),
    receiptNumber: () => ({
        presence: { allowEmpty: false },
        format: {
            pattern: /^[a-zA-Z\d]+$/,
        },
    }),
    totalAmount: () => ({
        presence: { allowEmpty: false },
        format: {
            pattern: /^\d+(?:\.\d{0,2})?$/,
        },
    }),
    birthday: (value, attribute, attributeName, messages) => {
        if (isEmpty(value)) {
            return {};
        }
        return {
            format: {
                pattern:
            /((0[1-9]|1[0-2])\/([01][1-9]|10|2[0-8]))|((0[13-9]|1[0-2])\/(29|30))|((0[13578]|1[0]|1[2])\/31|02\/29)/,
                message: `^${!get(messages, 'errorText', null) ? 'Please enter your birthday in a valid format, MM/DD' : messages.errorText}`,
            },
        };
    },
    '6 Digit Code': () => ({
        presence: { allowEmpty: false },
        format: {
            pattern: /^[0-9]*$/,
        },
    }),
};

export default constraints;
